import { MapPin } from '@insify/design-system/icons';
import {
  headingColor,
  headingXs,
  textMd,
  textMdSemibold,
  textXs,
  textXsSemibold,
} from '@insify/design-system/typography';
import { Map } from '@insify/map-component';
import clsx from 'clsx';

import * as styles from './CompanyDetails.module.css';

import type { Geolocation } from '@insify/map-component';

type Props = {
  className?: string;
  mapboxAccessToken: string;
  geolocation?: Geolocation;
  companyName: string;
  companyId?: string;
  headcountAndRevenueText: string;
  addressText: string;
  activitiesListTitle: string;
  activities: string[];
};

export const CompanyDetails = ({
  className,
  mapboxAccessToken,
  geolocation,
  companyName,
  companyId,
  headcountAndRevenueText,
  addressText,
  activitiesListTitle,
  activities,
}: Props): JSX.Element => {
  return (
    <section className={clsx(styles.card, className)}>
      <Map className={styles.map} coordinates={geolocation} accessToken={mapboxAccessToken} />
      <div className={styles.companyInfo}>
        <div className={styles.companyNameAndId}>
          <h3 className={clsx(headingColor, headingXs)}>{companyName}</h3>
          {companyId && <span className={clsx(textXsSemibold, styles.companyId)}>{companyId}</span>}
        </div>
        <p className={clsx(textXs, styles.headcountAndRevenue)}>{headcountAndRevenueText}</p>
        <p className={styles.address}>
          <MapPin className={styles.addressIcon} />
          <span className={clsx(textXs, styles.addressText)}>{addressText}</span>
        </p>
        <h4 className={clsx(textMdSemibold, styles.activitiesHeading)}>{activitiesListTitle}</h4>
        <ul className={clsx(textMd, styles.activitiesList)}>
          {activities?.map((activity) => (
            <li key={activity} className={styles.activity}>
              {activity}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
